// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer{align-items:center;border-radius:0 0 12px 12px;display:flex;padding:8px}.footer.resizing-layout{padding-left:var(--horizontal-padding);padding-right:var(--horizontal-padding)}.footer .analyze-btn{margin-right:8px}.footer .analyze-description{color:var(--gray3);font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
